import styled from 'styled-components';



export const CartDropdownContainer = styled.div`
  position: absolute;
  width: 480px;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid black;
  background-color: white;
  top: 90px;
  right: 0px;
  z-index: 5;

	button{
		margin-top: auto;
		width: 100%;
	}
	@media (max-width: 479px) {
		width: 370px;
	}
`;

export const EmptyMessage = styled.span`
  font-size: 18px;
  margin: 50px auto;
`;

export const CartItemsContainer = styled.div`
  height: 240px;
  display: flex;
  flex-direction: column;
  overflow: scroll;
`;